export const ratePlansTab = {
  sectionLabel: {
    title: "Tarifas visibles en la reserva directa",
    hintHotel:
      "Elige qué tarifas se muestran en cada tipo de habitación, el orden y la predeterminada.",
    hintApartment:
      "Elige qué tarifas ve el huésped, arrástralas para ordenar y marca la predeterminada.",
  },
  loading: "Cargando tarifas…",
  empty: {
    apartment: "No hay tarifas configuradas para esta propiedad.",
    hotel: "No hay tipos de habitación configurados para este hotel.",
    room: "No hay tarifas configuradas para esta habitación.",
  },
  derivedPill: "Derivada",
  dragHandleTitle: "Arrastrar para ordenar",
  visibleSwitchTitle: "Mostrar en la reserva directa",
  expandTitleClose: "Cerrar configuración",
  expandTitleOpen: "Configurar nombre, política y por defecto",
  visibleNameLabel: "Nombre visible",
  visibleNamePlaceholderApartment: "Ej: No reembolsable / Flexible",
  visibleNamePlaceholderHotel: "Ej: Desayuno incluido",
  cond: {
    refundable: "Se puede cancelar",
    refundableHint: "Tú decides hasta cuándo sale gratis.",
    nonRefundable: "No reembolsable",
    nonRefundableHint: "La reserva no se devuelve. El huésped puede cancelar, pero se le cobra el 100%. Lo ve antes de pagar.",
    freeDays: "Cancelación gratis hasta",
    freeDaysPlaceholder: "Sin límite",
    freeDaysHelp: "Días antes de la llegada. Vacío = gratis hasta el final.",
    penalty: "Después se cobra",
    penaltyHelp: "Del total de la estancia. 100% = no se devuelve nada.",
    sinGuardar: "Esta tarifa todavía no tiene condiciones guardadas. Lo de abajo es una propuesta: pulsa «Guardar política» para aplicarla.",
    aplicarTodas: "Aplicar a todas las habitaciones",
    aplicarTodasHelp: "Se pondrá la misma condición en la tarifa «{name}» de 1 habitación más. | Se pondrá la misma condición en la tarifa «{name}» de {count} habitaciones más.",
    notes: "Notas para el huésped (opcional)",
    previewNonRefundable: "El huésped leerá: «Esta tarifa no es reembolsable: la reserva no se puede cancelar».",
    previewFree: "El huésped leerá: «Cancelación gratuita hasta la llegada».",
    previewDayPenalty: "El huésped leerá: «Cancelación gratuita hasta el día de llegada; después se cobra el {pct}%».",
    previewUntilPenalty: "El huésped leerá: «Gratis hasta 1 día antes; después se cobra el {pct}%». | El huésped leerá: «Gratis hasta {count} días antes; después se cobra el {pct}%».",
    shortNonRefundable: "No reembolsable",
    shortFree: "Cancelación gratuita",
    shortDayPenalty: "Gratis hasta la llegada · luego {pct}%",
    shortUntilPenalty: "Gratis hasta 1 día antes · luego {pct}% | Gratis hasta {count} días antes · luego {pct}%",
  },
  cancellationPolicyLabel: "Política de cancelación",
  policyEmpty: "Sin política definida",
  policyEdit: "Editar",
  policyAdd: "Agregar",
  defaultLabel: "Por defecto",
  rulesApartment: "Reglas: mínimo 1 visible y 1 por defecto (que esté visible).",
  rulesRoom: "Cada habitación debe tener al menos 1 tarifa visible y 1 por defecto.",
  tip: "Consejo: define una tarifa “Flexible” por defecto y muestra otras como “No reembolsable”.",
  room: {
    ratePlansCount: "{count} tarifa | {count} tarifas",
    includedGuestsTitle:
      "A cuántas personas incluye el precio (para el cargo por huésped extra)",
    includes: "Incluye",
    person: "persona | personas",
    meta: "Capacidad: {capacity} • Adultos: {adults} • Niños: {children}",
  },
  modal: {
    eyebrow: "Política de cancelación",
    closeAria: "Cerrar",
    hint: "Este texto se mostrará al huésped en la reserva directa. Describe las condiciones de cancelación de esta tarifa.",
    textareaPlaceholder:
      "Ej: Cancelación gratuita hasta 48h antes del check-in. Después, se cobra la primera noche. No reembolsable en temporada alta.",
    clear: "Borrar",
    cancel: "Cancelar",
    saving: "Guardando…",
    save: "Guardar política",
    defaultTitle: "Tarifa",
  },
  toasts: {
    loadError: "No se pudieron cargar las tarifas.",
    saveSuccess: "Tarifas guardadas correctamente.",
    saveError: "No se pudieron guardar las tarifas.",
  },
  validation: {
    roomMinVisible: 'La habitación "{name}" debe tener al menos 1 tarifa visible.',
    roomOneDefault: 'La habitación "{name}" debe tener exactamente 1 tarifa por defecto.',
    roomDefaultVisible: 'En "{name}", la tarifa por defecto debe estar visible.',
    minVisible: "Debes dejar al menos 1 tarifa visible.",
    oneDefault: "Debe existir exactamente 1 tarifa por defecto.",
    defaultVisible: "La tarifa por defecto debe estar visible.",
  },
};
